import { Loader2 } from 'lucide-react';

/**
 * FE-1: no screen defines its own button.
 *
 * The variant names map onto the design system's restraint: `primary` is
 * graphite ink, not brand colour. Sapphire (`accent`) is reserved for state, so
 * it is available as a variant but rarely the right answer.
 */
const VARIANTS = {
  primary: 'btn-primary',
  secondary: 'btn-ghost',
  ghost: 'btn-subtle',
  danger: 'btn-danger',
  accent: 'btn-accent',
};

const SIZES = { sm: 'btn-sm', md: '', lg: 'btn-lg' };

export function Button({
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled = false,
  type = 'button',
  icon: Icon,
  className = '',
  children,
  ...props
}) {
  return (
    <button
      type={type}
      // FE-11: disabled while in flight, so double submission is impossible.
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      className={[VARIANTS[variant] ?? VARIANTS.primary, SIZES[size] ?? '', className].join(' ')}
      {...props}
    >
      {loading ? (
        <Loader2 className={size === 'sm' ? 'h-3.5 w-3.5 animate-spin' : 'h-4 w-4 animate-spin'} />
      ) : (
        Icon && <Icon className={size === 'sm' ? 'h-3.5 w-3.5' : 'h-4 w-4'} />
      )}
      {children}
    </button>
  );
}

export function IconButton({ icon: Icon, label, className = '', ...props }) {
  return (
    <button type="button" aria-label={label} className={`btn-icon ${className}`} {...props}>
      <Icon className="h-4 w-4" />
    </button>
  );
}

export default Button;
